var React = require('react');
var cx = require('classnames');

var AccessSelector = React.createClass({
  propTypes: {
    roles: React.PropTypes.arrayOf(React.PropTypes.string).isRequired,
    showPartner: React.PropTypes.bool.isRequired,
  },

  getDefaultProps: function () {
    return {
      roles : [],
      showPartner: false,
    }
  },

  componentWillMount: function () {
    this.setState({
      roles: this.props.roles,
    })
  },

  componentWillReceiveProps: function (nextProps) {
    this.setState({
      roles: nextProps.roles,
    })
  },

  componentWillUnmount: function () {
    this.setState({
      roles: [],
    })
  },

  getRoles: function() {
    return this.state.roles
  },

  handleChange: function (role, checked) {
    let roles = this.state.roles
    const index = roles.indexOf(role)

    if (!checked && index >= 0) {
      roles.splice(index, 1)
    } else if (checked && index === -1) {
      this.removeExtraRoles(roles, role)

      roles.push(role)
    }

    this.setState({
      roles,
    })
  },

  removeExtraRoles: function (roles, role) {
    function removeRole(roles, role) {
      const index = roles.indexOf(role)
      if (index >= 0) {
        roles.splice(index, 1)
      }
    }

    switch (role) {
      case 'OWNER':
        this.removeExtraRoles(roles, 'ADMIN')
        removeRole(roles, 'ADMIN')
        break;

      case 'ADMIN':
        this.removeExtraRoles(roles, 'TECH')
        removeRole(roles, 'ACCOUNTING')
        removeRole(roles, 'TECH')
        break;

      case 'TECH':
        removeRole(roles, 'TECH_VIEW')
        break;
    }
  },

  render: function () {
    const owner = this.state.roles.indexOf('OWNER') > -1
    const admin = this.state.roles.indexOf('ADMIN') > -1
    const accounting = this.state.roles.indexOf('ACCOUNTING') > -1
    const tech = this.state.roles.indexOf('TECH') > -1
    const techView = this.state.roles.indexOf('TECH_VIEW') > -1
    const partner = this.state.roles.indexOf('PARTNER') > -1

    return (
      <div className={cx('form-group', this.props.className)}>
        <label className="control-label">Choose Access Levels</label>
        <div className="checkbox">
          <label>
            <input
              type="checkbox"
              checked={owner}
              onChange={e => this.handleChange('OWNER', e.target.checked)}
            /> Owner
          </label>
        </div>
        <div className="checkbox">
          <label>
            <input
              type="checkbox"
              checked={admin || owner}
              disabled={owner}
              onChange={e => this.handleChange('ADMIN', e.target.checked)}
            /> Admin
          </label>
        </div>
        <div className="checkbox">
          <label>
            <input
              type="checkbox"
              checked={accounting || admin || owner}
              disabled={admin || owner}
              onChange={e => this.handleChange('ACCOUNTING', e.target.checked)}
            /> Accounting
          </label>
        </div>
        <div className="checkbox">
          <label>
            <input
              type="checkbox"
              checked={tech || admin || owner}
              disabled={admin || owner}
              onChange={e => this.handleChange('TECH', e.target.checked)}
            /> Technical Manage
          </label>
        </div>
        <div className="checkbox">
          <label>
            <input
              type="checkbox"
              checked={techView || tech || admin || owner}
              disabled={tech || admin || owner}
              onChange={e => this.handleChange('TECH_VIEW', e.target.checked)}
            /> Technical View
          </label>
        </div>
        {this.props.showPartner && (
          <div className="checkbox">
            <label>
              <input
                type="checkbox"
                checked={partner}
                onChange={e => this.handleChange('PARTNER', e.target.checked)}
              /> Partner Access
            </label>
          </div>
        )}

        {this.props.children}
      </div>
    )
  }
});

module.exports = AccessSelector;



// WEBPACK FOOTER //
// ./app/components/Access/AccessSelector.js